import { PageContainer } from "components/shared";
import "./styles.css";

/**
 * @function CaptureNotShownView
 * @param {STRING} message - The message to be shown.
 * @returns {React.Component}
 * @description This component is used for component captures in conditions where the capture 
 * should not be shown. This is usually when a branding option is set to a certain value that is not compatible
 * with the capture. The styles applied in this component are those that have been used in captures over
 * the years.
 */
export default function CaptureNotShownView(props) {
    const message = props.message;

    return (
        <PageContainer className={ `no-background` }>
            <div className="capture-not-shown-view">
                <h1>{ message }</h1>
            </div>
        </PageContainer>
    );
}